import {searchBtn} from "./components/searchBtn";
import {ajax} from "./crud/ajax";

searchBtn();
ajax();
